import axios from '../lib/axios.js'

export default class BackendAPI {
  // An HTTP fetch() API wrapper that returns JSON
  constructor() {
    this.baseUrl = "";
  }

  // Useful to seperate flow like /cart API calls and /payment API calls.
  setBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
  }

  getBaseUrl() {
    return this.baseUrl;
  }

  // HTTP GET request that returns a promise and converts to JSON.
  get(endpoint) {
    return axios.get(this.baseUrl + endpoint)
    .then(response => response.data)
    .catch(error => error.response.data);
  }

  // HTTP POST request that takes JSON in the body,
  // returns a promise and converts to JSON.
  post(endpoint, data = {}) {
    return axios.post(this.baseUrl + endpoint, data, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
    .then(response => response.data)
    .catch(error => {
      if (error.response && error.response.status === 429) {
        return { error: true, message: 'Too many attempts.', status_code:429 };
      }
      return error.response.data;
    });
  }
  

  // Another HTTP POST request that takes raw form data in body
  // and returns JSON.
  form_post(endpoint, data) {
    return axios.post(this.baseUrl + endpoint, data, { 
      credentials: "same-origin" 
    })
    .then(response => response.data)
    .catch(error => error.response.data);
  }

  delete(endpoint) {
    return axios.delete(this.baseUrl + endpoint, {
        headers: {
          'Content-Type': 'application/json',
        }
    })
    .then(response => response.data)
    .catch(error => error.response.data)
  }

}
